module.exports = __webpack_public_path__ + "media/images/favicons/mstile-310x310-1074fe51962739c8c930f633744bfc96.png";